export const MESSAGES_STORE_NAME = 'lc-messages';
export const CONTACTS_IDX = 'contacts-idx';
export const CONTACTS_TS_IDX = 'contacts-ts-idx';
export const TS_IDX = 'ts-idx';
export const LC_MESSAGE_ID_IDX = 'lc-message-id-idx';
export const CLIENT_MESSAGE_ID_IDX = 'client-message-id-idx';

export type DialogueMessagePayload = {
  dialogueId: number;
  dialogueName: string;
};

export type MediaMessagePayload = {
  assetId?: number;
  file: File;
};

export type TextMessagePayload = {
  text: string;
};

export type ReactionMessagePayload = {
  reaction: 'like';
};

export type ContactMessagePayload =
  | DialogueMessagePayload
  | MediaMessagePayload
  | TextMessagePayload
  | ReactionMessagePayload;

export type ContactMessage = {
  remoteUserId: string;
  time: Date;
  clientMessageId: string;
  lcMessageId?: string;
  conversationSessionId?: number;
  message: ContactMessagePayload;
  error?: string;
};

export type ExtendedContactMessage = Omit<ContactMessage, 'time'> & {
  time: string;
  conversationSessionId: number;
};

export const isContactMessage = (
  value: any,
): value is ExtendedContactMessage => {
  return (
    typeof value === 'object' &&
    'clientMessageId' in value &&
    'message' in value
  );
};
